import IcRotateLeft from './IcRotateLeft'

export default IcRotateLeft
